import { Box, Button, Paper, Rating, Typography } from '@mui/material'
import React from 'react'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import profileImage from '../../images/profileImage.jpg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { useNavigate } from 'react-router-dom';
function ProfileCard({ coach }) {
    const navigate = useNavigate();
    return (
        <>
            {
                coach != undefined
                    ?
                    <Paper
                        sx={{
                            position: 'relative',
                            border: '1px solid',
                            borderColor: '#8BACF84D',
                            backgroundColor: '#F8FAFF',
                            padding: '20px',
                            borderRadius: '10px',
                            textAlign: 'center',
                            boxShadow: '0px 10px 47px 0px #3665D014',
                        }}
                    >
                        <BookmarkBorderIcon
                            sx={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                            }}
                        />
                        <img
                            src={coach?.avatar}
                            alt="Image"
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '100px',
                                height: '100px',
                                borderRadius: '10px'
                            }}
                        />

                        <Typography className='subHeading1Bold' mt={5}>{coach?.name}</Typography>
                        <Rating className='subHeading2Bold' readOnly precision={0.1} value={4.7} />
                        <Typography className='text1Mid' style={{ opacity: '0.5' }}>{coach.skills.map((item) => item.skill).join(", ")}</Typography>
                        <Button
                            className='text2Mid'
                            sx={{
                                py: 1,
                                mt: 1,
                                backgroundColor: '#2544EE',
                                borderRadius: '0.5rem',
                                color: '#fff',
                                border: '1px solid #2544EE',
                                '&:hover': {
                                    color: '#2544EE',
                                    backgroundColor: '#fff'
                                },
                            }}
                            endIcon={<ArrowForwardIosOutlinedIcon />}
                            onClick={() => navigate(`/candidate/coach-detail/${coach._id}`)}
                            variant="contained"
                        >
                            View Profile
                        </Button >
                    </Paper>
                    :
                    <Paper
                        sx={{
                            position: 'relative',
                            border: '1px solid',
                            borderColor: '#8BACF84D',
                            backgroundColor: '#F8FAFF',
                            padding: '20px',
                            borderRadius: '10px',
                            textAlign: 'center',
                            boxShadow: '0px 10px 47px 0px #3665D014',
                        }}
                    >
                        <BookmarkBorderIcon
                            sx={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                            }}
                        />
                        <img
                            src={profileImage}
                            alt="Image"
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '100px',
                                height: '100px',
                                borderRadius: '10px'
                            }}
                        />

                        <Typography className='subHeading1Bold' mt={5}>Amit Sharma</Typography>
                        <Rating className='subHeading2Bold' readOnly precision={0.1} value={4.7} />
                        <Typography className='text1Mid' style={{ opacity: '0.5' }}>New Manager, Executives, Career Changers, Relocating New managers, Executives</Typography>
                        <Button
                            className='text2Mid'
                            sx={{
                                py: 1,
                                mt: 1,
                                backgroundColor: '#2544EE',
                                borderRadius: '0.5rem',
                                color: '#fff',
                                border: '1px solid #2544EE',
                                '&:hover': {
                                    color: '#2544EE',
                                    backgroundColor: '#fff'
                                },
                            }}
                            endIcon={<ArrowForwardIosOutlinedIcon />}
                            // onClick={handleSubmit}
                            variant="contained"
                        >
                            View Profile
                        </Button >
                    </Paper>

            }
        </>
    )
}

export default ProfileCard